import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import Home from "./pages/Home";

import Teams from "./pages/Teams";
import Navbar from "./components/Navbar";

import Community from "./pages/Community";

import Member from "./pages/Member";
import Footer from "./components/Footer";
import { Route, Switch } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import { DataContext } from "./api/DataContext";
function App() {
  // aos init
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <>
      <DataContext>
        <Navbar />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/team" component={Teams} />
          <Route path="/team/:userId" component={Member} />

          <Route path="/community" component={Community} />
        </Switch>
        <Footer />
      </DataContext>
    </>
  );
}

export default App;
